import React from "react";
import ReactDOM from "react-dom";

const centerModalNew = (props) => {
  const modal = (
    <div
      className="modal dismissible fade"
      id={props.modalId}
      aria-hidden="true"
      aria-labelledby="centerModal"
      role="dialog"
      tabIndex="-1"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-simple modal-center">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={props.onHide}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">{props.modalTitle}</h4>
          </div>
          <div className="modal-body">{props.children}</div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default btn-pure"
              style={{ fontWeight: 400 }}
              data-dismiss="modal"
              onClick={props.onHide}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document === "undefined") {
    return null;
  }

  return ReactDOM.createPortal(modal, document.body);
};

export default centerModalNew;
